/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule, ModuleWithProviders } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NbBadgeModule, NbIconModule, NbSidebarModule } from '@nebular/theme';
// import { NbSharedModule } from '@nebular/theme/components/shared/shared.module';

import { DgMenuItemComponent } from './menu-item.component';
import { DgMenuComponent } from './menu.component';
import { DgMenuService } from './menu.service';


const NB_MENU_PROVIDERS = [DgMenuService];

@NgModule({
  imports: [
    // NbSharedModule,
    NbIconModule,
    NbBadgeModule,
    BrowserModule,
    NbSidebarModule.forRoot(),
    RouterModule.forRoot([])
  ],
  declarations: [DgMenuComponent, DgMenuItemComponent],
  exports: [DgMenuComponent, DgMenuItemComponent],
  providers: NB_MENU_PROVIDERS
})
export class DgMenuModule {
  // static forRoot(): ModuleWithProviders<DgMenuModule> {
  //   return {
  //     ngModule: DgMenuModule,
  //     providers: [
  //       ...NB_MENU_PROVIDERS,
  //     ],
  //   };
  // }
}
